
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { CampsPriviligesApiService } from '../../infrastructure/infrastructure.module';
import { BcPrivilegesProviderService } from '@bayclubs/employee-auth';


@Injectable()
export class CampsPriviligesProviderService extends BcPrivilegesProviderService {
    public scope = 'Camps';

    constructor(private privileges: CampsPriviligesApiService) {
        super();
    }

    getPrivileges(): Observable<any> {
        return this.privileges.getPriviliges().pipe(map(x => x.value));
    }
}
